import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { useLoaderStore } from './loader.store';
import * as kafkaAccessApi from '../api/kafkaAccess.api';

export const useKafkaUsersStore = defineStore('kafkaUsers', () => {
    const users = ref([]);
    const loader = useLoaderStore();

    return {
        users,
        all: computed(() => users.value),
        fetch: async () => {
            loader.activateLoading('kafkaUsers.fetch');
            try {
                const response = await kafkaAccessApi.fetchKafkaUsers();
                users.value = response?.data?.result || response?.data || response;
            } catch (error) {
                console.error(error);
            } finally {
                loader.deactivateLoading('kafkaUsers.fetch');
            }
        },
        addUser: async (user) => {
            loader.activateLoading('kafkaUsers.add');
            try {
                const response = await kafkaAccessApi.createKafkaUser(user);
                users.value.push(response?.data || response);
                return response;
            } catch (error) {
                console.error(error);
            } finally {
                loader.deactivateLoading('kafkaUsers.add');
            }
        },
        updateUser: async (username, user) => {
            loader.activateLoading('kafkaUsers.update');
            loader.activateLoading(`kafkaUsers.update.${username}`);
            try {
                const response = await kafkaAccessApi.updateKafkaUser(username, user);
                const updated = response?.data || response;
                const index = users.value.findIndex((u) => u.username === username);
                if (index !== -1) {
                    users.value.splice(index, 1, updated);
                }
                return response;
            } catch (error) {
                console.error(error);
            } finally {
                loader.deactivateLoading('kafkaUsers.update');
                loader.deactivateLoading(`kafkaUsers.update.${username}`);
            }
        },
        deleteUser: async (username) => {
            loader.activateLoading('kafkaUsers.delete');
            loader.activateLoading(`kafkaUsers.delete.${username}`);
            try {
                await kafkaAccessApi.deleteKafkaUser(username);
                users.value = users.value.filter((u) => u.username !== username);
            } catch (error) {
                console.error(error);
            } finally {
                loader.deactivateLoading('kafkaUsers.delete');
                loader.deactivateLoading(`kafkaUsers.delete.${username}`);
            }
        }
    };
});
